import React, { useEffect, useState } from 'react';
import { useGenericCRUD } from '@/hooks/useGenericCRUD';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Plus, Trash, Edit } from 'lucide-react';
import { toast } from '@/components/ui/use-toast';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export default function MultiespecialistasPage() {
  const { data, loading, fetchAll, create, update, remove } = useGenericCRUD('sys_especialistas', 'data_criacao', false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({ nome: '', email: '', telefone: '', especialidade: '', status: 'Ativo' });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const handleSave = async () => {
    try {
      if (editingId) await update(editingId, formData);
      else await create(formData);
      toast({ title: 'Sucesso', description: 'Especialista salvo!' });
      setIsModalOpen(false);
    } catch (e) {
      toast({ title: 'Erro', description: e.message, variant: 'destructive' });
    }
  };

  const getStatusColor = (status) => {
    if(status === 'Ativo') return 'bg-green-100 text-green-800';
    if(status === 'Suspenso') return 'bg-red-100 text-red-800';
    return 'bg-gray-100 text-gray-800';
  }

  return (
    <div className="p-6 bg-white rounded-lg shadow-sm">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-[#193D6D]">Multiespecialistas</h1>
        <Button onClick={() => { setEditingId(null); setFormData({ nome: '', email: '', telefone: '', especialidade: '', status: 'Ativo' }); setIsModalOpen(true); }} className="bg-[#193D6D] text-white">
          <Plus className="w-4 h-4 mr-2" /> Novo Especialista
        </Button>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm text-left border">
          <thead className="bg-gray-50 border-b">
            <tr><th className="p-4">Nome</th><th className="p-4">Especialidade</th><th className="p-4">Contato</th><th className="p-4">Status</th><th className="p-4">Ações</th></tr>
          </thead>
          <tbody>
            {data.map(item => (
              <tr key={item.id} className="border-b hover:bg-gray-50">
                <td className="p-4 font-medium">{item.nome}</td>
                <td className="p-4">{item.especialidade}</td>
                <td className="p-4"><div className="text-xs">{item.email}</div><div className="text-xs text-gray-500">{item.telefone}</div></td>
                <td className="p-4"><span className={`px-2 py-1 rounded-full text-xs font-semibold ${getStatusColor(item.status)}`}>{item.status}</span></td>
                <td className="p-4 flex gap-2">
                  <Button variant="ghost" size="icon" onClick={() => { setFormData(item); setEditingId(item.id); setIsModalOpen(true); }}><Edit className="w-4 h-4" /></Button>
                  <Button variant="ghost" size="icon" className="text-red-500" onClick={() => remove(item.id)}><Trash className="w-4 h-4" /></Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>{editingId ? 'Editar Especialista' : 'Novo Especialista'}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <Input placeholder="Nome Completo" value={formData.nome} onChange={e => setFormData({...formData, nome: e.target.value})} className="text-gray-900" />
            <Input placeholder="E-mail" type="email" value={formData.email} onChange={e => setFormData({...formData, email: e.target.value})} className="text-gray-900" />
            <Input placeholder="Telefone" value={formData.telefone} onChange={e => setFormData({...formData, telefone: e.target.value})} className="text-gray-900" />
            <Input placeholder="Especialidade (Ex: Grafotécnico, Contábil)" value={formData.especialidade} onChange={e => setFormData({...formData, especialidade: e.target.value})} className="text-gray-900" />
            <select className="flex h-10 w-full rounded-md border bg-white px-3 py-2 text-gray-900" value={formData.status} onChange={e => setFormData({...formData, status: e.target.value})}>
              <option value="Ativo">Ativo</option><option value="Inativo">Inativo</option><option value="Suspenso">Suspenso</option>
            </select>
            <Button onClick={handleSave} className="w-full">Salvar</Button>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}